<template>
    <div>
        <a @click="goBack" style="font-size: 40px; color: blue;">&nbsp;&nbsp;&lt;</a>
        <div class="list-group">
            <span class="list-group-item">
                <h6>{{$t('flow.no')}}. {{uuid}}</h6>
                <h6>{{$t('flow.creationTime')}}: {{creationTime}}</h6>
                <h6>{{$t('flow.startTime')}}: {{startTime}}</h6>
            </span>
            <li class="list-group-item" v-for="(item, index) in tasks" :key=index>
                {{$t('task.station')}}{{item.stationseq+1}}&nbsp;&nbsp;{{item.target}}: {{$t(translateStatus(item.status))}}
                <span v-if='item.completiontime.startsWith("0000")'></span><span v-else>.&nbsp;&nbsp;{{item.completiontime}}</span>
            </li>
                
            <a href="#idRequest" v-if="cancellable" class="btn btn-secondary wfeButton" data-toggle="modal"><span>{{$t('task.cancel')}}</span></a>
        </div>
        
        <div id="idRequest" class="modal fade" tabindex="-1">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog vertical-align-center">
                    <div class="modal-content">
                        <div class="modal-header textCenter">
                            {{$t('task.cancel')}}
                            <br/>
                            {{$t('cancel.confirm')}}
                        </div>
    
                        <div class="modal-footer" style="margin: 0 auto;">
                            <button type="button" class="btn btn-primary" data-dismiss="modal" @click='makeCancel'>{{$t('common.ok')}}</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('common.cancel')}}</button>
                        </div>
                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>
        </div>

        <div id="idRequestResponse" class="modal fade" tabindex="-1">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog vertical-align-center">
                    <div class="modal-content">
                        <div class="modal-body textCenter">
                            {{$t('task.cancel')}}
                            <br/>
                            {{$t('task.cancelled')}}
                            <br/>
                            <span style="text-align: left;">No. {{uuid}}</span>
                        </div>
    
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">{{$t('common.ok')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

import router from '../router'
import {translateStatus} from '../utils/translate'

export default {
    props: ['uuid', 'creationTime', 'startTime'],

    data() {
        return {
            cancellable: true,
            newTasks: []
        }
    },

    watch: {
        newTasks: function() {
            this.checkCancellable()
        }
    },

    created() {
        this.$store.dispatch('actGetTasks', this.uuid)
    },

    computed: {
        tasks: function() {
			//console.log('computed->tasks: ', this.getTasks)
            this.newTasks = this.getTasks.map(function(elm) {
                return JSON.parse(elm)
            })
            return this.newTasks
        },
        ...mapGetters([
            'getTasks'
        ])
    },

    methods: {
        checkCancellable() {
            //console.log('checkCancellabe():newTasks: ', this.newTasks)
            if (this.newTasks.length != 0 && 
                (this.newTasks[this.newTasks.length-1].status == 3 
                    || this.newTasks[this.newTasks.length-1].status == 4
                    || this.newTasks[this.newTasks.length-1].status == 5)) {
                this.cancellable = false
            } else {
                this.cancellable = true
            }
        },
        translateStatus: translateStatus,
        ...mapActions([
            'actCancelFlow',
            'actGetTasks'
        ]),
        async makeCancel() {
            await this.actCancelFlow(this.uuid) // double async/await is neccessary
			this.goBack()
        },        
        goBack() {
            router.go(-1)
        }
    }
}
</script>

<style scoped src='../assets/css/custom.css'></style>

<style scoped>
.wfeButton {
    background-color: purple;
    color: white;
    margin: 20px 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Task.vue